import { color } from "@mui/system";
import React, { useState } from "react";
import style from "./inputform.module.css";


function InputForm(props) {

    const [error, setError] = useState("");
    const [modified, setModified] = useState(false);
    const value = props.value;

    let checkIsValid = function(content) {

        if(props.required && content.target.value === "") {
            setError("Ce champ est obligatoire.");
            return false;
        }

        // Vérification format email
        if(props.type === "mail") {
            let regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/i);

            if(!regex.test(content.target.value)) {
                setError("Adresse email incorrecte.");
                return false;
            }
        }

        // Vérification téléphone
        if(props.type === "phone") {
            let regex = new RegExp(/^(\+33|0)[0-9]{9}$/);

            if(!regex.test(content.target.value)) {
                setError("Numéro de téléphone incorrecte.");
                return false;
            }
        }

        // Vérification code postal
        if(props.type === "zipcode") {
            let regex = new RegExp(/^[0-9]{5}$/);

            if(!regex.test(content.target.value)) {
                setError("Code postal incorrecte.");
                return false;
            }
        }

        // Vérification de la date
        if(props.type === "date" && props.agemin && props.agemax) {
            let diff = (props.when ? new Date(props.when) : Date.now()) - new Date(content.target.value);
            let age = new Date(diff);
            age = Math.abs(age.getUTCFullYear() - 1970);

            if(age < props.agemin) {
                setError("L'âge doit être compris entre " + props.agemin + " et " + props.agemax + " ans. (lors du stage)");
                return false;
            }
            else if(age > props.agemax) {
                setError("L'âge doit être compris entre " + props.agemin + " et " + props.agemax + " ans. (lors du stage)");
                return false;
            }
        }

        if(props.type === "number") {
            let regex = new RegExp(/^[0-9]+$/);

            if(!regex.test(content.target.value)) {
                setError("Veuillez saisir un nombre.");
                return false;
            }

            if(props.min && content.target.value < props.min) {
                setError("La valeur doit être supérieure à " + props.min);
                return false;
            }

            if(props.max && content.target.value > props.max) {
                setError("La valeur doit être inférieure à " + props.max);
                return false;
            }
        }
        
        setError(false);
        return true;
    }

    let handleTyping = function(content) {
        if(checkIsValid(content)) {
            props.controller(props.name, content.target.value);
        }
        else {
            props.controller(props.name, null);
        }
        if(props.modifIndicator) {
            setModified(true);
        }
    }

    return (
        <span className={style.span}>
            <label className={style.label} for={props.name}> {props.libelle} { props.required ? <p>(*)</p> : null }</label>
            {props.type == "textarea" ? 
            
            <textarea style={error ? {minHeight: 100, borderColor: 'red'} : (modified ? {minHeight: 100, borderColor: 'orange'} : {minHeight: 100})} onChange={ handleTyping } onBlur={ handleTyping } className="simpleInput" type={props.type} name={props.name} placeholder={props.placeholder} id={props.id} value={props.value} autoFocus={props.autoFocus}></textarea>
             : 
             <input id={props.id} onChange={ handleTyping } onBlur={ handleTyping } className="simpleInput" type={props.type} name={props.name} placeholder={props.placeholder} value={props.value} autoFocus={props.autoFocus} disabled={props.disabled}
                style={error ? {borderColor: 'red'} : (modified ? {borderColor: 'orange'} : null)}
            />
            }
            <p className={style.error}>{error}</p>
        </span>
    )
}

export default InputForm;